import { ButtonBase, styled as muiStyled } from '@mui/material'
import styled from 'styled-components'

export const PSAQCContainer = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  padding: 0px;
  height: 100vh;
  max-height: 400px;
  @media (min-width: 576px) {
    padding: 0px 0px 232px 0px;
    max-height: 640px;
  }
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 0px 0px 0px 0px;
  }
`

export const PSAQCSecondPart = styled.div`
  width: 100%;
  display: flex;
  gap: 2px;
  position: absolute;
  bottom: 0;
  right: 0;
  justify-content: center;
  @media (min-width: 768px) {
    justify-content: right;
  }
`

export const PSAQCFirstPartComponentWrapper = styled.div`
  font-size: 32px;
  color: #000;
  font-family: Outfit;
  font-weight: 700;
  text-align: left;
  margin-bottom: 40px;
  @media (min-width: 768px) {
    text-align: left;
    width: 70%;
    font-size: 45px;
  }
  @media (min-width: 1200px) {
    text-align: left;
    width: 70%;
    font-size: 56px;
  }
`

export const PASQComponentFirstPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 20px 20px 20px;
  align-items: center;

  @media (min-width: 576px) {
    align-items: start;
  }
  @media (min-width: 768px) {
    position: unset;
    padding: 20px 0px 20px 20px;
  }
  @media (min-width: 1200px) {
    position: unset;
    padding: 20px 0px 20px 90px;
  }
`

export const PSAQCActionButton = muiStyled(ButtonBase)(
  ({ theme }) => `
  background-color: #000000;
  border-radius: 20px;
  color: white;
  padding: 14px 20px;
  letter-spacing: 2px;
  transition: all 300ms ${theme.transitions.easing.quickInOut};
  &:hover {
    background: #a9b8f9;
    color: #000;
  }
  @media (min-width: 768px) {
    padding: 14px 40px;
  }
`,
)

export const PSAQMentorImage = muiStyled('img')(
  ({ theme }) => `
  display: none;
    width: 100%;
    object-fit: cover;
    // height: 100%;
    object-position: left;
    max-width: 377px;
    width: 100%;
    gap: 2px;
    position: absolute;
    bottom: 36px;
    right: -111px;
    height: 70%;
    @media(min-width: 576px){
      display: block;
    }
  @media(min-width: 768px){
    height: unset;
      position: unset;
    }
`,
)
